{
  "familyId": "SPR-TREMA-MV",
  "questions": [
    {
      "id": "SPR-TREMA-MV-001",
      "familyId": "SPR-TREMA-MV",
      "module": "SpellingRegel",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "leestekens",
      "subSkill": "trema_meervoud",
      "questionType": "multiple_choice",
      "question": "Wat is het correcte meervoud van 'bacterie'?",
      "options": ["bacteriën", "bacterien", "bacterie's", "bacterieën"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {"type": "rule", "showWhen": "wrong", "data": {"title": "Trema bij meervoud", "content": "Als twee klinkers naast elkaar komen te staan in het meervoud, gebruik je een trema (¨) om te laten zien dat je ze apart uitspreekt.\n\nbacterie + ën = bacteriën\nDe ë laat zien: spreek de e apart uit van de i.", "icon": "book"}}
      ],
      "conceptId": "trema_meervoud_bacterien",
      "variantIndex": 1,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Het meervoud van 'bacterie' is 'bacteriën'. De trema (¨) op de e laat zien dat je de e apart uitspreekt: bacteri-ën, niet 'bacterien' (wat je als 'bacterien' zou lezen). Zonder trema smelten de klinkers samen.",
        "solutionSteps": [
          "Bacterie + en = bacteriën",
          "De i en e komen naast elkaar → trema nodig",
          "Trema op de ë: bacteriën",
          "Spreek uit: bacteri-ën (apart) ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Bacteriën — met trema op de ë.",
          "1": "Zonder trema lees je 'bacterien' als één klank. De trema scheidt de klinkers: bacteri-ën. Onthoud: trema = apart uitspreken.",
          "2": "Een apostrof (') gebruik je niet bij meervouden op -en. Het is bacteriën (met trema), niet bacterie's.",
          "3": "'Bacterieën' heeft een extra e. Het meervoud is bacterie + ën = bacteriën, niet bacterie + eën."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "spr.trema-forgotten", "label": "Trema vergeten", "optionIndex": 1 },
          { "id": "spr.trema-apostrophe", "label": "Apostrof i.p.v. trema", "optionIndex": 2 },
          { "id": "spr.trema-extra-vowel", "label": "Extra klinker toegevoegd", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-TREMA-MV-002",
      "familyId": "SPR-TREMA-MV",
      "module": "SpellingRegel",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "leestekens",
      "subSkill": "trema_meervoud",
      "questionType": "multiple_choice",
      "question": "Wat is het correcte meervoud van 'idee'?",
      "options": ["ideeen", "idee's", "ideeën", "ideën"],
      "correctAnswer": 2,
      "stimulusAids": [],
      "supportAids": [
        {"type": "rule", "showWhen": "wrong", "data": {"title": "Trema bij dubbele klinker", "content": "Bij 'idee' eindigt het woord op -ee. Het meervoud is -en.\nidee + en → ideeën\n\nDe trema laat zien: de laatste e hoort bij '-en', niet bij 'idee'. Zo lees je idee-ën, niet 'ideeen'.", "icon": "book"}}
      ],
      "conceptId": "trema_meervoud_ideeen",
      "variantIndex": 2,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Het meervoud van 'idee' is 'ideeën'. Er komen drie e's naast elkaar (idee + en). De trema op de derde e laat zien waar het meervoud begint: idee-ën. Zonder trema zou je 'ideeen' als één lang woord lezen.",
        "solutionSteps": [
          "Idee + en = ideeën",
          "Drie e's naast elkaar → trema nodig",
          "Trema op de ë: ideeën",
          "Spreek uit: idee-ën (apart) ✓"
        ],
        "distractorExplanations": {
          "0": "Zonder trema lees je 'ideeen' als één klank. De trema scheidt het woord: idee-ën.",
          "1": "Een apostrof (') gebruik je bij meervouden op -s (idee's is ook correct!). Maar het standaard meervoud op -en is ideeën.",
          "2": "Goed! Ideeën — met trema op de derde e.",
          "3": "'Ideën' mist een e. Het woord 'idee' heeft twee e's: idee + ën = ideeën."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "spr.trema-forgotten", "label": "Trema vergeten", "optionIndex": 0 },
          { "id": "spr.trema-apostrophe", "label": "Apostrof-meervoud", "optionIndex": 1 },
          { "id": "spr.trema-extra-vowel", "label": "Klinker weggelaten (ideën)", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-TREMA-MV-003",
      "familyId": "SPR-TREMA-MV",
      "module": "SpellingRegel",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "leestekens",
      "subSkill": "trema_meervoud",
      "questionType": "multiple_choice",
      "question": "Bij welk woord is de trema CORRECT geplaatst?",
      "options": ["geinteresseerd", "geïnteresseerd", "ge-interesseerd", "geïntereseerd"],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        {"type": "rule", "showWhen": "wrong", "data": {"title": "Trema na voorvoegsel", "content": "Na voorvoegsels zoals ge-, be-, ver- gebruik je een trema als het volgende deel met dezelfde klinker begint.\n\nge + interesseerd → geïnteresseerd\nDe ï laat zien: spreek ge- en in- apart uit.", "icon": "book"}}
      ],
      "conceptId": "trema_voorvoegsel",
      "variantIndex": 3,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Na het voorvoegsel 'ge-' begint 'interesseerd' met een i. Twee klinkers naast elkaar (e + i) → trema: geïnteresseerd. De trema laat zien dat je ge- en in- apart uitspreekt. Zonder trema zou je 'gein-' lezen.",
        "solutionSteps": [
          "Herken het voorvoegsel: ge- + interesseerd",
          "De e van ge- en de i van in- komen naast elkaar",
          "Trema op de ï: geïnteresseerd",
          "Spreek uit: ge-ïn-te-res-seerd ✓"
        ],
        "distractorExplanations": {
          "0": "Zonder trema lees je 'gein-teresseerd'. De trema scheidt de klinkers: ge-ïnteresseerd.",
          "1": "Goed! Geïnteresseerd — trema op de ï na het voorvoegsel ge-.",
          "2": "Een koppelteken (-) gebruik je niet na voorvoegsels. Gebruik een trema: geïnteresseerd, niet ge-interesseerd.",
          "3": "'Geïntereseerd' mist een s. Het woord is 'interesseerd' (met dubbele s): geïnteresseerd."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "spr.trema-forgotten", "label": "Trema vergeten", "optionIndex": 0 },
          { "id": "spr.accent-type-confused", "label": "Koppelteken i.p.v. trema", "optionIndex": 2 },
          { "id": "spr.trema-forgotten", "label": "Trema + spelfout (één s)", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-TREMA-MV-007",
      "familyId": "SPR-TREMA-MV",
      "module": "SpellingRegel",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "leestekens",
      "subSkill": "trema_meervoud",
      "questionType": "true_false_series",
      "question": "Beoordeel of elk meervoud correct gespeld is.",
      "data": {
        "statements": [
          { "text": "'Bacteriën' is correct gespeld.", "isTrue": true },
          { "text": "'Ideeen' is correct gespeld.", "isTrue": false },
          { "text": "'Koloniën' is correct gespeld.", "isTrue": true },
          { "text": "'Zeeën' is correct gespeld.", "isTrue": true },
          { "text": "'Bacterie's' is correct gespeld.", "isTrue": false }
        ]
      },
      "correctAnswer": [true, false, true, true, false],
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Trema bij meervoud", "content": "Als twee klinkers naast elkaar komen in het meervoud, gebruik je een trema (¨). 'Ideeen' mist de trema → ideeën. 'Bacterie's' gebruikt een apostrof i.p.v. trema → bacteriën.", "icon": "book" } }],
      "conceptId": "trema_tf_series",
      "variantIndex": 7,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Regel: als twee klinkers naast elkaar komen in het meervoud, gebruik je een trema (¨) om aan te geven dat je ze apart uitspreekt. 'Bacteriën' ✓ (i + ë apart), 'koloniën' ✓ (i + ë apart), 'zeeën' ✓ (ee + ë apart). 'Ideeen' ✗ mist de trema → moet 'ideeën' zijn (drie e's naast elkaar). 'Bacterie's' ✗ gebruikt een apostrof — bij meervoud op -en gebruik je een trema, geen apostrof.",
        "solutionSteps": [
          "Bacteriën: trema op ë → correct ✓",
          "Ideeen: drie e's zonder trema → fout (ideeën)",
          "Koloniën: trema op ë → correct ✓",
          "Zeeën: trema op ë → correct ✓",
          "Bacterie's: apostrof i.p.v. trema → fout (bacteriën)"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SPR-TREMA-MV-008",
      "familyId": "SPR-TREMA-MV",
      "module": "SpellingRegel",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "leestekens",
      "subSkill": "trema_meervoud",
      "questionType": "categorize",
      "question": "Sorteer deze woorden: bij welke is een trema nodig in het meervoud en bij welke niet?",
      "data": {
        "categories": ["Trema nodig", "Geen trema nodig"],
        "items": [
          { "text": "bacterie → bacteriën", "correctCategory": 0 },
          { "text": "boek → boeken", "correctCategory": 1 },
          { "text": "idee → ideeën", "correctCategory": 0 },
          { "text": "stoel → stoelen", "correctCategory": 1 },
          { "text": "kolonie → koloniën", "correctCategory": 0 },
          { "text": "tafel → tafels", "correctCategory": 1 }
        ]
      },
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Wanneer trema?", "content": "Een trema is nodig als twee klinkers naast elkaar komen en je ze apart moet uitspreken:\nbacterie + en → bacteriën (i + e botsen)\nidee + en → ideeën (e + e + e botsen)\nkolonie + en → koloniën (i + e botsen)\n\nGeen trema als er geen klinkerbotsing is:\nboek + en → boeken, stoel + en → stoelen, tafel + s → tafels.", "icon": "book" } }],
      "conceptId": "trema_categorize",
      "variantIndex": 8,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Trema nodig: bacterie → bacteriën (i en e botsen), idee → ideeën (drie e's naast elkaar), kolonie → koloniën (i en e botsen). Geen trema nodig: boek → boeken (k en e botsen niet — medeklinker + klinker), stoel → stoelen (l en e botsen niet), tafel → tafels (meervoud op -s, geen klinkerbotsing). Regel: alleen als twee klinkers naast elkaar komen in het meervoud, heb je een trema nodig.",
        "solutionSteps": [
          "Bacterie + en: i + e → klinkerbotsing → trema ✓",
          "Boek + en: k + e → geen klinkerbotsing → geen trema",
          "Idee + en: e + e + e → klinkerbotsing → trema ✓",
          "Stoel + en: l + e → geen klinkerbotsing → geen trema",
          "Kolonie + en: i + e → klinkerbotsing → trema ✓",
          "Tafel + s: geen klinkerbotsing → geen trema"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SPR-TREMA-MV-004",
      "familyId": "SPR-TREMA-MV",
      "module": "SpellingRegel",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "leestekens",
      "subSkill": "trema_meervoud",
      "questionType": "multiple_choice",
      "question": "Welk woord heeft een trema nodig?",
      "options": ["boeken", "stoelen", "tafels", "zeeën"],
      "correctAnswer": 3,
      "stimulusAids": [],
      "supportAids": [
        {"type": "rule", "showWhen": "wrong", "data": {"title": "Wanneer trema?", "content": "Een trema is nodig als twee klinkers naast elkaar komen en je ze apart moet uitspreken.\n\nzee + en → zeeën (drie e's → trema)\nboek + en → boeken (geen klinkerbotsing → geen trema)\n\nGeen trema nodig als de klinkers niet botsen.", "icon": "book"}}
      ],
      "conceptId": "trema_wanneer_nodig",
      "variantIndex": 4,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Alleen 'zeeën' heeft een trema nodig. Zee + en = zeeën — drie e's naast elkaar, dus de trema scheidt ze: zee-ën. Bij boeken, stoelen en tafels botsen er geen klinkers, dus is geen trema nodig.",
        "solutionSteps": [
          "Zeeën: zee + en → drie e's → trema nodig ✓",
          "Boeken: boek + en → geen klinkerbotsing",
          "Stoelen: stoel + en → geen klinkerbotsing",
          "Tafels: tafel + s → geen klinkerbotsing"
        ],
        "distractorExplanations": {
          "0": "Boeken heeft geen trema nodig. Boek + en → de k en e botsen niet. Trema is alleen nodig bij klinker + klinker.",
          "1": "Stoelen heeft geen trema nodig. Stoel + en → de l en e botsen niet.",
          "2": "Tafels heeft geen trema nodig. Tafel + s → geen klinkerbotsing.",
          "3": "Goed! Zeeën heeft een trema: zee + en → drie e's naast elkaar."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "spr.trema-forgotten", "label": "Geen klinkerbotsing herkend", "optionIndex": 0 },
          { "id": "spr.trema-forgotten", "label": "Geen klinkerbotsing herkend", "optionIndex": 1 },
          { "id": "spr.trema-forgotten", "label": "Geen klinkerbotsing herkend", "optionIndex": 2 }
        ]
      }
    },
    {
      "id": "SPR-TREMA-MV-005",
      "familyId": "SPR-TREMA-MV",
      "module": "SpellingRegel",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "leestekens",
      "subSkill": "trema_meervoud",
      "questionType": "fill_in",
      "question": "Schrijf het meervoud van 'kolonie'. Typ het hele woord.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["koloniën", "kolonien"],
        "caseSensitive": false,
        "placeholder": "typ het meervoud"
      },
      "stimulusAids": [],
      "supportAids": [
        {"type": "rule", "showWhen": "wrong", "data": {"title": "Kolonie + ën", "content": "Kolonie eindigt op -ie. Het meervoud is -en.\nkolonie + en → koloniën\n\nDe trema laat zien: de e hoort bij -en, niet bij -ie. Spreek uit: koloni-ën.", "icon": "book"}}
      ],
      "conceptId": "trema_meervoud_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Het meervoud van 'kolonie' is 'koloniën'. De i en e komen naast elkaar (kolonie + en), dus gebruik je een trema: koloni-ën. De trema laat zien dat je de klinkers apart uitspreekt.",
        "solutionSteps": [
          "Kolonie + en = koloniën",
          "De i en e botsen → trema nodig",
          "Trema op de ë: koloniën",
          "Spreek uit: koloni-ën ✓"
        ]
      }
    },
    {
      "id": "SPR-TREMA-MV-006",
      "familyId": "SPR-TREMA-MV",
      "module": "SpellingRegel",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "leestekens",
      "subSkill": "trema_meervoud",
      "questionType": "error_spotting",
      "question": "Zoek de spelfout in deze tekst en verbeter het woord.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "text": "De biologieleraar vertelde over bacterien en virussen. De leerlingen schreven alles op in hun schrift.",
        "errors": [
          {
            "word": "bacterien",
            "position": 5,
            "correction": "bacteriën",
            "explanation": "Bacterie + en: de i en e komen naast elkaar → trema nodig. Bacteriën, niet bacterien."
          }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Trema bij meervoud", "content": "Als twee klinkers naast elkaar komen in het meervoud, gebruik je een trema (¨).\nbacterie + en → bacteriën\nDe trema laat zien: spreek de e apart uit van de i.", "icon": "book" } }
      ],
      "conceptId": "trema_error_spotting",
      "variantIndex": 6,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "'Bacterien' mist de trema. Het meervoud van 'bacterie' is 'bacteriën' — met trema op de ë. De trema laat zien dat je de klinkers apart uitspreekt: bacteri-ën. Zonder trema smelten de klinkers samen. 'Virussen' is correct — daar botsen geen klinkers.",
        "solutionSteps": [
          "Bacterie + en: de i en e komen naast elkaar",
          "Klinkerbotsing → trema nodig",
          "Correct: bacteriën (met trema op de ë)",
          "Virussen: geen klinkerbotsing → geen trema nodig ✓"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    }
  ]
}